import { Component, OnInit, HostListener } from "@angular/core";

@Component({
  selector: "app-portal-layout",
  templateUrl: "./portal-layout.component.html",
  styleUrls: ["./portal-layout.component.scss"]
})
export class PortalLayoutComponent implements OnInit {
  isMobileResolution: boolean;

  constructor() {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }
  @HostListener("window:resize", ["$event"])
  isMobile($event: any) {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }
  ngOnInit() {}
}
